import React from "react"
import ReactDOM from "react-dom"
import { UserProfile } from "../../hooks/userProfile"
import * as trackingHelpers from "../../helpers/tracking"

export default class PageView {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.dataset.url = window.location.href
    this.init()
    return self
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(
      <UserProfile>
        {(profile) => {
          if (profile === null || Object.keys(profile).length) {
            trackingHelpers.pageView(this.elem.dataset, profile)
          }
          return null
        }}
      </UserProfile>,
      this.elem,
    )
  }
}
